"use client";

export default function NotFound() {
  return <div className="h-screen flex flex-col">NOT FOUND</div>;
}
